import { createProvidedContext } from './utils/react.js';
const [useComponents, ComponentsContextProvider] = createProvidedContext('Components');
export { useComponents, ComponentsContextProvider };
